import { createSlice } from "@reduxjs/toolkit"
import { mailTemplateFormObject } from "@form/mailTemplateFormFields"

const mailTemplatesSlice = createSlice({
  name: 'mailTemplates',
  initialState: {
    mailTemplates: [],
    mailTemplateTypes: [],
    mailTemplateFormObject: { ...mailTemplateFormObject },
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateMailTemplateFormObject: (state, action) => {
      state.mailTemplateFormObject = action.payload
    },
    addMailTemplate: (state, action) => {
      const template = action.payload
      state.mailTemplates = { ...state.mailTemplates, [template.id]: template }
    },
    updateMailTemplates: (state, action) => {
      state.mailTemplates = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateMailTemplateFormObject, addMailTemplate, updateMailTemplates, updateErrors } = mailTemplatesSlice.actions

export default mailTemplatesSlice.reducer